import React from 'react';

import { Button } from '../../../components/Buttons/Button';

import { useIsNewDeploymentAvailable } from '../../../components/hooks/useIsNewDeploymentAvailable';
import useNotifications from '../../../_lib/notifications/useNotifications';

const Action = () => {
  return <Button style={{ paddingTop: 6, color: '#1f1f29' }}>UPDATE</Button>;
};

export const withVersionSnackbar = (Component: any) => {
  return (props: any) => {
    const notifications = useNotifications();

    const isNewDeploymentAvailable = useIsNewDeploymentAvailable();

    const enqueueVersionSnackbar = React.useCallback(() => {
      notifications.show({
        type: 'warning',
        title: 'New version of platform available!',
        action: Action,
        position: 'top-center',
        persist: true,
        preventDuplicate: true,
        onClick: () => {
          // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
          window.location.reload(true);
        },
      });
    }, [notifications]);

    // useIsNewDeploymentAvailable polls /api/console-version and compares the
    // deployed build against the one this tab booted from. That works on both
    // the Cloudflare Pages and Docker paths, so it is the only mechanism here.
    React.useEffect(() => {
      if (isNewDeploymentAvailable) {
        enqueueVersionSnackbar();
      }
    }, [enqueueVersionSnackbar, isNewDeploymentAvailable]);

    return <Component {...props} />;
  };
};
